module.exports = __webpack_public_path__ + "static/man_set_6adult.efacd71c.svg";